import React from "react"

import {Text} from "./styles"

export function LitText({children, ...rest}){
  return (
    <Text {...rest}>{children}</Text>
  )
}
